import React, { Component } from "react";
import PropTypes from "prop-types";
import "./css/jquery.dataTables.css";
import "./css/custom.css";

const $ = require("jquery");
$.DataTable = require("datatables.net");

class DataTable extends Component {
  componentDidMount() {
    this.$el = $(this.el);
    this.$el.DataTable({
      responsive: true,
      searching: this.props.searching,
      bInfo: this.props.bInfo,
      bLengthChange: false,
      paging: this.props.paging,
      columns: this.props.columns,
      data: this.props.data,
      order: [],
      ordering: this.props.ordering,
    });
  }
  componentWillReceiveProps(props) {
    $(this.el).dataTable().fnDestroy();

    this.$el = $(this.el);
    this.$el.DataTable({
      responsive: true,
      searching: props.searching,
      bInfo: props.bInfo,
      bLengthChange: false,
      paging: props.paging,
      columns: props.columns,
      data: props.data,
      order: [],
      ordering: this.props.ordering,
    });
  }
  componentWillUnmount() {
    this.$el.DataTable().destroy(true);
  }
  render() {
    return (
      <div className="tableStyle">
        <table className="display" width="100%" ref={(el) => (this.el = el)} />
      </div>
    );
  }
}

DataTable.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      sTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      title: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }).isRequired
  ),
  data: PropTypes.arrayOf(PropTypes.array).isRequired,
  paging: PropTypes.bool,
  searching: PropTypes.bool,
  bInfo: PropTypes.bool,
  ordering: PropTypes.bool,
};
export default DataTable;



// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/Datatable/DataTable.jsx